<template>
  <div class="list-group">
    <template v-for="equipment in equipments" :key="equipment.id">
      <!--
        Two variants rather than one: a row is a <button>, and the availability control cannot be
        nested inside it. Consumers that do not need it keep the original single-button row.
      -->
      <div
        v-if="withAvailability"
        class="list-group-item d-flex align-items-center p-0"
      >
        <button
          type="button"
          class="btn btn-link text-body text-decoration-none text-left flex-grow-1 d-flex align-items-center justify-content-between px-3 py-2"
          @click="onClick(equipment)"
        >
          <EquipmentInfo :item="equipment" />

          <equipment-status :status="equipment.current_status" class="ml-auto"></equipment-status>

          <test-status :in-progress="equipment.tests_in_progress" class="ml-2"></test-status>
        </button>

        <button
          type="button"
          class="btn btn-link px-3"
          :title="$t('View availability')"
          :aria-label="$t('View availability')"
          @click.stop="emit('availabilityRequested', equipment)"
        >
          <i class="fa fa-calendar"></i>
        </button>
      </div>

      <button
        v-else
        type="button"
        class="list-group-item list-group-item-action"
        @click="onClick(equipment)"
      >
        <span class="d-flex align-items-center w-100 justify-content-between">
          <EquipmentInfo :item="equipment" />

          <equipment-status
            :status="equipment.current_status"
            class="ml-auto"
          ></equipment-status>

          <test-status
            :in-progress="equipment.tests_in_progress"
            class="ml-2"
          ></test-status>
        </span>
      </button>
    </template>
  </div>
</template>

<script setup>
import EquipmentStatus from "./EquipmentStatus.vue";
import TestStatus from "./TestStatus.vue";
import EquipmentInfo from "@/components/equipment/EquipmentInfo.vue";

// Define props
const props = defineProps({
  equipments: {
    type: Array,
    default: () => [],
  },
  /** Adds a per-row control to inspect when the item is taken. */
  withAvailability: {
    type: Boolean,
    default: false,
  },
});

// Define emits
const emit = defineEmits(['equipmentSelected', 'availabilityRequested']);

// Methods
const onClick = (equipment) => {
  emit('equipmentSelected', equipment);
};
</script>

<style scoped>

</style>
